var React = require('react');

function InteractiveMapPin (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M23.9167 0C10.6942 0 0 10.6942 0 23.9167C0 41.8542 23.9167 68.3333 23.9167 68.3333C23.9167 68.3333 47.8333 41.8542 47.8333 23.9167C47.8333 10.6942 37.1392 0 23.9167 0ZM23.9167 32.4583C19.2017 32.4583 15.375 28.6317 15.375 23.9167C15.375 19.2017 19.2017 15.375 23.9167 15.375C28.6317 15.375 32.4583 19.2017 32.4583 23.9167C32.4583 28.6317 28.6317 32.4583 23.9167 32.4583Z","fill":"#3D332E"}));
}

InteractiveMapPin.defaultProps = {"width":"48","height":"69","viewBox":"0 0 48 69","fill":"none"};

module.exports = InteractiveMapPin;

InteractiveMapPin.default = InteractiveMapPin;
